type StatValueTextProps = {
  value: number;
  className?: string;
};

/** Figma `*_value` — Shnobel 66, white, shadow #4D3C82. */
export function StatValueText({ value, className }: StatValueTextProps) {
  return (
    <svg
      className={className}
      width={133}
      height={60}
      viewBox="0 0 133 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <text
        className="stats-content__value-text"
        textAnchor="middle"
        xmlSpace="preserve"
      >
        <tspan x={66.5} y={52}>
          {value}
        </tspan>
      </text>
    </svg>
  );
}
